import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Wrench, FileText, MessageSquare, Camera, Image as ImageIcon, Video } from 'lucide-react';

const ToolsSection = ({ toolkit }) => {
  const templates = toolkit.implementation.captionTemplates;
  const questions = toolkit.implementation.interviewQuestions;
  
  return (
    <div className="space-y-8">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center">
          <Wrench className="w-6 h-6 text-blue-700" />
        </div>
        <div>
          <h2 className="text-2xl font-bold text-gray-900">Implementation Tools</h2>
          <p className="text-gray-600">Caption templates, interview scripts, and photo guidelines</p>
        </div>
      </div>

      <Card className="border-2 border-green-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <FileText className="w-5 h-5 text-green-700" />
            Caption Templates
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {templates.map((template, idx) => (
            <div key={idx} className="p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div className="flex items-start gap-3">
                <span className="w-6 h-6 bg-green-700 text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">
                  {idx + 1}
                </span>
                <p className="text-gray-700 text-sm">{template}</p>
              </div>
            </div>
          ))}
        </CardContent>
      </Card>

      <Card className="border-2 border-purple-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <MessageSquare className="w-5 h-5 text-purple-700" />
            Interview Questions
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-3">
          {questions.map((question, idx) => (
            <div key={idx} className="flex items-start gap-3 p-3 bg-purple-50 rounded-lg">
              <span className="w-6 h-6 bg-purple-700 text-white rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0">
                {idx + 1}
              </span>
              <p className="text-gray-700">{question}</p>
            </div>
          ))}
        </CardContent>
      </Card>

      <Card className="border-2 border-amber-200">
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Camera className="w-5 h-5 text-amber-700" />
            Photo & Video Guidelines
          </CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-700 leading-relaxed mb-6">{toolkit.implementation.photoGuidelines}</p>
          <div className="grid grid-cols-3 gap-4">
            <div className="text-center p-4 bg-amber-50 rounded-lg">
              <ImageIcon className="w-8 h-8 text-amber-600 mx-auto mb-2" />
              <p className="text-sm font-medium text-gray-700">Min. 5 photos per story</p>
            </div>
            <div className="text-center p-4 bg-amber-50 rounded-lg">
              <Video className="w-8 h-8 text-amber-600 mx-auto mb-2" />
              <p className="text-sm font-medium text-gray-700">1-2 min video clips</p>
            </div>
            <div className="text-center p-4 bg-amber-50 rounded-lg">
              <Camera className="w-8 h-8 text-amber-600 mx-auto mb-2" />
              <p className="text-sm font-medium text-gray-700">Natural lighting preferred</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ToolsSection;
